import React, { useEffect, useState } from "react";

export default function AIMessageBox() {
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchAIContent = async () => {
      try {
        // Fetch greeting
        const greetRes = await fetch("/api/ai/greet", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const greetData = await greetRes.json();
        
        // Fetch trending topic
        const topicRes = await fetch("/api/ai/topic", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const topicData = await topicRes.json();
        
        const greeting = greetData.greetings || "Welcome back!";
        const topic = topicData.topic || "Stay productive today!";
        
        setMessage(`${greeting}\n\n📰 Today's Tech Insight: ${topic}`);
      } catch (err) {
        console.error(err);
        setMessage("AI service unavailable right now 😅");
      }
    };
    fetchAIContent();
  }, [token]);

  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 border-l-4 border-blue-500 p-4 rounded-xl shadow-md">
      <h3 className="font-bold text-lg mb-2 text-gray-800">
        AI Insights
      </h3>
      <p className="text-gray-700 whitespace-pre-line leading-relaxed">{message}</p>
    </div>
  );
}
